export default __webpack_public_path__ + "file-asset/b1065e51972f234033e70a498230469b-letter.svg";